// import { useState } from "react";
// import { useQuery } from "react-query";
// import { IOpportunity } from "../../common/constants/app.dto";
// import { CardProcess } from "../../common/components/card/process";
// import { Field } from "../../common/components/controls/field";
// import { Loading } from "../../common/components/loading";
import { textChooser } from "../../common/util/textChooser";

export const MyProcess = () => {

    // const {isLoading, isSuccess, data} = useQuery("favorites" , getFavorites);
    // const [filter , setFilter] = useState("");
    
    // const handleFilterProcess = ({target: {value}}: any) => {
    //     setFilter(value);
    // }

    // const filteredData = data?.filter((opportunity: IOpportunity) =>{
    //     const name = opportunity.name.toLocaleLowerCase();
    //     const desc = opportunity.description.toLocaleLowerCase();
    //     const filterStr = filter.toLocaleLowerCase();

    //     if(name.includes(filterStr) || desc.includes(filterStr)) {
    //         return opportunity;
    //     }
    // })
    
    return (
        <div className="page -my_process">
            <h1 className="page-title">{textChooser("txt58")}</h1>

            {/* <section className="my_process-contollers">
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <Field 
                            type="search"
                            hasError={false}
                            hasIcon={false}
                            placeholder={textChooser("txt154")}
                            onChange={handleFilterProcess}
                            maxLength={60}
                            minLength={0}
                        />
                    </div>
                </div>
            </section>

            <section className="my_process-section">
                {isLoading && <Loading />}

                {isSuccess && (filteredData as IOpportunity[]).map((ops) => 
                    <CardProcess {...ops} key={ops.id} />
                )}
            </section> */}
        </div>
    )
}